document.addEventListener('DOMContentLoaded', function() {
    const bestSellersContainer = document.querySelector('.dtc-mobile-menu__best-sellers-items');
    const bestSellersCustomScroll = document.querySelector('.dtc-mobile-menu__best-sellers-scrollbar span');

    if (!!!bestSellersContainer || !!!bestSellersCustomScroll) return;

    bestSellersContainer.addEventListener('scroll', () => {
        const containerWidth = bestSellersContainer.clientWidth;
        const scrollWidth = bestSellersContainer.scrollWidth;
        const thumbWidth = bestSellersCustomScroll.offsetWidth;
        
        let scrollPercentage = (bestSellersContainer.scrollLeft / (scrollWidth - containerWidth)) * 100;
        
        const maxLeft = 100 - (thumbWidth / containerWidth) * 100;

        if (scrollPercentage > maxLeft) scrollPercentage = maxLeft;
    
        bestSellersCustomScroll.style.left = `${ scrollPercentage }%`;
    });
})